import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  type?: "button" | "submit";
}

/**
 * Sticky bottom CTA button · 1:1 design `.tg-main`. Pinned to viewport
 * bottom, always above the bottom-nav. In real TG WebView this can be
 * swapped for `Telegram.WebApp.MainButton` later — for now we render the
 * in-page button so the design works in any browser preview.
 */
export function TgMain({ children, disabled, onClick, type = "button" }: Props) {
  return (
    <button
      type={type === "submit" ? "submit" : "button"}
      className="tg-main"
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
